import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  FilterConfig,
  LeadColumn,
  LeadRow,
  LeadsTable,
} from '../../components/shared/leads-table/leads-table';
import { Observable, of, Subscription } from 'rxjs';
import { LeadsFilaRequest, LeadsFilaResponse } from '../../interfaces/leads-fila.interface';
import { ServerSidePaginationModel } from '../../components/shared/leads-table/models/serverSidePagination.model';
import { availableOriginsType } from '../../components/shared/filter-fields/models/filter-field.model';
import { Router, RouterModule } from '@angular/router';
import { LeadsDataService } from '../../services/data/Leads.data.service';
import { LeadsFilaService } from '../../services/leads-fila.service';
import { SelectedDnService } from '../../services/selected-dn.service';
import { DateUtil } from '../../utils/date-utils';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { Header } from '../../components/shared/header/header';

@Component({
  selector: 'subscription-renew',
  imports: [CommonModule, RouterModule, Header, LeadsTable],
  templateUrl: './subscription-renew.html',
  styleUrl: './subscription-renew.scss',
})
export class SubscriptionRenew implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild(LeadsTable) leadsTable?: LeadsTable;

  tableColumns: LeadColumn[] = [
    { key: 'nome', label: 'Nome', type: 'text' },
    { key: 'terminoContrato', label: 'Data término de contrato', type: 'text' },
    { key: 'disponivelDesde', label: 'Disponível desde', type: 'text' },
    { key: 'retornarEm', label: 'Retornar em', type: 'text' },
    { key: 'status', label: 'Status do Lead', type: 'status' }
  ];

  filterConfig: FilterConfig = {
    searchFields: ['nome'],
    alphabeticalField: 'NM_NOME',
    filterFields: {
      renewal: 'renovaMais',
      origin: 'origem'
    },
    dateField: 'dataTerminoContrato'
  };

  leadsFilaRequest!: LeadsFilaRequest;
  tableData: LeadRow[] = [];
  loading: boolean = false;
  loadingMessage: string = 'Carregando dados...';
  errorMessage: string = '';
  emptyMessage: string = 'Nenhum lead encontrado para o tipo de campanha informada.';
  serverSidePagination = new ServerSidePaginationModel();
  availableFilterOrigins: availableOriginsType[] = [
    'S&D-PF',
    'S&D-PJ',
    'S&D-CONCESSIONARIOS',
    'S&D-COBRANDED',
  ];

  private dnSubscription?: Subscription;
  private hasLoadedInitialData = false;
  private hasReceivedInitialDates = false;
  private isLoading = false;
  private initialLoadDone = false;
  private currentSearchText: string | undefined = undefined;
  private currentFilters: string[] = [];
  private currentDateRange: { start: string; end: string } = { start: '', end: '' };
  private currentSortField: string = 'dataSimulacao';
  private currentSortOrder?: 'ASC' | 'DESC' = 'DESC';

  private readonly tipoCampanha = 6;

  constructor(
    private readonly router: Router,
    private leadsDataService: LeadsDataService,
    private leadsFilaService: LeadsFilaService,
    private selectedDnService: SelectedDnService,
  ) {}

  ngOnInit(): void {
    this.currentDateRange = DateUtil.getDateRange(3);

    this.dnSubscription = this.selectedDnService.selectedDn$.subscribe((dn) => {
      if (dn && this.hasReceivedInitialDates && this.initialLoadDone) {
        this.loadData();
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (!this.hasLoadedInitialData && !this.hasReceivedInitialDates && !this.isLoading) {
        this.hasReceivedInitialDates = true;
        this.loadData();
      }
    }, 200);
  }

  ngOnDestroy(): void {
    if (this.dnSubscription) {
      this.dnSubscription.unsubscribe();
    }
  }

  onDateRangeChange(dateRange: { start: string; end: string }): void {
    if (
      this.currentDateRange.start === dateRange.start &&
      this.currentDateRange.end === dateRange.end
    ) {
      return;
    }

    this.hasReceivedInitialDates = true;

    if (dateRange.start && dateRange.end) {
      this.currentDateRange = dateRange;
    } else {
      this.currentDateRange = dateRange;
    }

    this.loadData();
  }

  onSortChange(sort: { field: string; order: 'ASC' | 'DESC' }): void {
    this.currentSortField = sort.field;
    this.currentSortOrder = sort.order;
    this.serverSidePagination.set();
    this.serverSidePagination.pageSize = this.serverSidePagination?.pageSize || 20;
    this.loadData();
  }

  onSearchChange(searchText: string): void {
    this.currentSearchText = searchText;
    this.serverSidePagination.set();
    this.loadData();
  }

  onFilterChange(filters: string[]): void {
    this.currentFilters = filters;
    this.serverSidePagination.set();
    this.loadData();
  }

  onClearAllFilters(): void {
    this.currentSearchText = '';
    this.currentFilters = [];
    this.currentDateRange = { start: '', end: '' };
    this.currentSortField = '';
    this.currentSortOrder = 'DESC';
    this.hasReceivedInitialDates = true;
    this.loadData();
  }

  onPageSizeChange(newPageSize: number): void {
    this.serverSidePagination.pageSize = newPageSize;
    this.loadData();
  }

  onPageChange(newPage: number): void {
    if (this.serverSidePagination) {
      this.serverSidePagination.page = newPage;
      this.loadData();
    }
  }

  onViewLead(lead: LeadRow): void {
    if (lead.idLead) {
      this.router.navigate([`/leads/${lead.idLead}/detalhes`]);
    }
  }

  private loadData(): void {
    if (this.isLoading) return;

    //! (sem padrõnização)
    //! ISSO NÃO TA LEGAL NÃO, ZERAR PADRÕES NO MEIO DO FLUXO DE DADOS,
    this.isLoading = true;
    this.loading = true;
    this.loadingMessage = 'Carregando simulações...';
    this.errorMessage = '';
    this.emptyMessage = 'Nenhum lead encontrado para o tipo de campanha informada.';

    this.montLeadsFilaRequest();

    this.leadsFilaService.getLeadsFila(this.leadsFilaRequest).subscribe({
      next: (response: LeadsFilaResponse | null) => {
        this.resolveResponse(response);
      },
      error: (err: HttpErrorResponse) => {
        this.resolveError(err);
      },
    });
  }

  private resolveError(error: HttpErrorResponse): Observable<null> {
    this.isLoading = false;
    this.loading = false;

    if (error.status === 401) {
      this.errorMessage = 'Não autorizado. Redirecionando...';
      setTimeout(() => {
        this.router.navigate(['/login']);
      }, 2000);
    } else if (error.status === 204) {
      this.emptyMessage = 'Nenhum lead encontrado para o tipo de campanha informada.';
      this.tableData = [];
    } else {
      this.errorMessage = 'Erro ao carregar dados. Tente novamente.';
    }

    return of(null);
  }

  private montLeadsFilaRequest(): void {
    this.leadsFilaRequest = this.leadsDataService.montLeadsFilaRequest(
      this.tipoCampanha,
      this.selectedDnService.getSelectedDnAsNumber(),
      this.currentFilters,
      this.currentSearchText,
      this.currentDateRange,
      this.serverSidePagination,
      this.currentSortField,
      this.currentSortOrder,
    );
  }

  private resolveResponse(response: LeadsFilaResponse | null) {
    this.isLoading = false;
    this.loading = false;

    //! Por que (response.data.length > 0) neste  IF é necessário ? response?.data.length não seria suficiente?
    if (response && response.data && response.data.length > 0) {
      this.tableData = this.leadsDataService.mapLeadResponse(response.data);
      this.serverSidePagination.set(
        response.pagination.totalRecords,
        response.pagination.page,
        response.pagination.pageSize,
        response.pagination.from,
        response.pagination.to,
      );

      this.hasLoadedInitialData = true;
      this.initialLoadDone = true;
    } else {
      this.emptyMessage =
        response?.message || 'Nenhum lead encontrado para o tipo de campanha informada.';
      this.tableData = [];
      this.hasLoadedInitialData = true;
      this.initialLoadDone = true;
    }
  }
}
